<template>
  <v-layout>
    <v-flex>
      <v-row align="center" no-gutters>
        <v-col class="text-left ml-n6" cols="12" md="6">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
        <v-col class="text-right"  cols="12" md="6">
          <ActionButtons
            @doClose="doClose"
            @doRefresh="doRefresh"
            :actionBtnSettings="actionBtnSettings"
          >
          </ActionButtons>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Update Delievery Order
          <v-spacer></v-spacer>
          <DeliveryStatus :status="delivery.status" :statuses="statuses" v-if="!isStatusLoading"></DeliveryStatus>
        </v-card-title>
        <v-card-subtitle>
          #{{delivery.delivery_no}}
          <v-spacer></v-spacer>
        </v-card-subtitle>
        <v-card-text class="text--primary mt-6">
          <AlertMessage :alerMessage="alerMessage"></AlertMessage>
          <v-row>
            <v-col cols="12" sm="12" md="5">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="delivery.deliver_to_name"
                    label="Deliver To"
                    hide-details
                    outlined
                    readonly
                  ></v-text-field>


                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="delivery.deliver_to_contact_no"
                    label="Contact No."
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="delivery.deliver_to_address"
                    label="Address"
                    auto-grow
                    rows="1"
                    outlined
                    hide-details
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="delivery.plate_no"
                    label="Plate No."
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="12" md="5" offset-md="2">
              <v-row>
                <v-col cols="12">
                  <v-menu
                      v-model="menuCreatedDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="delivery.delivery_date"
                          label="Dispatch Date"
                          append-icon="mdi-calendar"
                          readonly
                          hide-details
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="delivery.delivery_date"
                        @input="menuCreatedDate = false"
                      ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="delivery.ref_no"
                    label="Reference No."
                    hide-details
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="delivery.remarks"
                    label="Remarks"
                    auto-grow
                    rows="1"
                    outlined
                    maxlength="255"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-card-title class="text-h6 mt-10 mr-0 pr-0">
            <v-spacer></v-spacer>
            <v-btn
              class="ml-md-10"
              large
              depressed
              color="primary"
              @click="showForDelivery()"
            >
              <v-icon dark class="mr-2">
                mdi-note-plus-outline
              </v-icon>
              Add Item For Delivery Order
            </v-btn>
          </v-card-title>

          <v-sheet
            rounded
            class="pa-5 px-6 pb-7"
            color="#f3f3f3">

            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              class="item-data-input"
              :items-per-page="1000"
              hide-default-footer
              loading-text="Loading Items..."
              no-data-text="No Items"
              ref="table">

              <template v-slot:item.shipping_mark="props">
                <v-text-field
                  class="bg-white"
                  v-model="props.item.shipping_mark"
                  placeholder="Shipping Mark"
                  dense
                  outlined
                  disabled
                  readonly
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.description="props">
                <v-text-field
                  class="bg-white"
                  v-model="props.item.description"
                  placeholder="Description"
                  dense
                  disabled
                  outlined
                  hide-details
                ></v-text-field>
              </template>

              <template v-slot:item.qty="props">
                <v-text-field
                  class="centered-input bg-white"
                  v-model="props.item.qty"
                  @focus="$event.target.select()"
                  placeholder="Qty"
                  dense
                  disabled
                  outlined
                  @keypress="filter($event)"
                  hide-details
                ></v-text-field>
              </template>


              <template v-slot:item.action="{ item }">
                <v-icon
                  color=" darken-2"
                  @click="deleteItem(item)">
                  mdi-close
                </v-icon>
              </template>

              <!-- <template v-slot:body.append>
                <tr>
                  <td class="text-center" colspan="6">
                    <div class="mt-4">
                          <v-btn
                            fab
                            dark
                            small
                            depressed
                            color="primary"
                            class="mb-1"
                            @click="addMoreItems()"
                          >
                            <v-icon dark>
                              mdi-plus
                            </v-icon>
                          </v-btn>
                          <br>
                          <span class="primary-color font-weight-medium">Add Item</span>
                    </div>
                  </td>
                </tr>
              </template> -->

            </v-data-table>

          </v-sheet>
        </v-card-text>
        <v-card-actions class="ml-2 my-2 mt-4">
          <v-btn
            color="primary"
            depressed
            large
            @click="doSave()">
            <span v-if="loading" class="mx-4">Please wait...</span>
            <span v-if="!loading" class="mx-4">Save Delivery Order</span>
          </v-btn>
        </v-card-actions>

      </v-card>

      <v-dialog v-model="forDeliveryDialog.show" persistent max-width="800px" content-class="default-dialog-container">
        <ForDelivery
          :forDeliveryDialog="forDeliveryDialog"
          @selectItem="selectItem"
          >
        </ForDelivery>
      </v-dialog>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
      <ConfirmationDialog
        :dialog="dialog"
        @doConfirm="doConfirm"
        @doCancel="doCancel"
      >
      </ConfirmationDialog>
      <Loader :loading="loading"></Loader>
    </v-flex>
  </v-layout>
</template>

<script>
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import { required, email, max, numeric } from 'vee-validate/dist/rules'
  import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
  import Loader from '@/components/Loader.vue'
  import ConfirmationDialog from '@/components/dialog/ConfirmationDialog.vue'
  import { mapGetters } from "vuex";
  import ActionButtons from '@/components/ActionButtons.vue'
  import AlertMessage from '@/components/AlertMessage.vue'
  import ForDelivery from '@/components/ForDelivery.vue'
  import DeliveryStatus from '@/components/DeliveryStatus.vue'

  setInteractionMode('eager')

  extend('required', {
    ...required,
    message: '{_field_} can not be empty',
  })

  extend('max', {
    ...max,
    message: '{_field_} may not be greater than {length} characters',
  })

  extend('email', {
    ...email,
    message: 'Email must be valid',
  })

  extend('numeric', {
    ...numeric,
    message: '{_field_} should be numeric',
  })

  export default {
    name: 'DOUpdate',
    props: ['id'],
    data: () => ({
      operationsNamespace: 'operations',
      forDeliveryDialog: {
        show: false,
        selected_items: [],
        client_id: ''
      },
      menuCreatedDate: false,
      loading: false,
      isStatusLoading: false,
      awaitingSearch: false,
      deletedItems: [],
      client: null,
      search: null,
      menuEstDeliveryDate: false,
      perPage: 2000,
      actionBtnSettings: {
        edit: 0,
        save: 1,
        refresh: 1,
        close: 1,
        print: 0,
        send: 1,
        save_and_print: 0,
        save_disabled: false,
        close_disabled: false,
        print_disabled: false,
        save_and_print_disabled: false
      },
      alerMessage:{
        show: false,
        status: '',
        type: 'error',
        omitMessage: '',
        messages: []
      },
      delivery: {
        id: '',
        delivery_no: '',
        ref_no: '',
        plate_no: '',
        deliver_to_name: '',
        deliver_to_contact_no: '',
        deliver_to_address: '',
        delivery_date: '',
        remarks: '',
        sub_total: 0,
        discounts: 0,
        other_charges: 0,
        net_amount: 0
      },
      dialog: {
        show: false,
        title: 'Delete Item',
        body: 'Are you sure you want to delete this item?',
        type: '',
        item: {},
        confirmBtn: 'Yes',
        cancelBtn: 'Cancel'
      },
      statuses: [],
      subNavs: [
        {
          text: 'Delivery Orders',
          disabled: false,
          exact: true,
          to: {
            name: 'delivery-orders'
          },
        },
        {
          text: 'Update Delivery Order',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      items: [],
      headers: [
        {
          text: 'Shipping Mark',
          align: 'start',
          value: 'shipping_mark',
          sortable: false,
          width: 270
        },
        {
          text: 'Item',
          align: 'start',
          value: 'description',
          sortable: false
        },
        {
          text: 'Qty',
          align: 'center',
          value: 'qty',
          sortable: false,
          width: 180
        },
        {
          text: 'x',
          value: 'action',
          align: 'center',
          sortable: false,
          width: 50
        }
      ]
    }),
    watch: {
    },
    computed: {
      ...mapGetters(['formatNumberAmount', 'formatNumber', 'formatNumberAmountNoComma', 'getCurrentUser']),
      forUpdate: function(){
        return this.id ? true : false
      },
    },
    methods: {
      scrollToElement (element, body) {
        this.$scrollTo(
          element,
          500,
          {
            container: body,
            easing: 'ease-in',
            lazy: false,
            offset: -100,
            force: true,
            cancelable: true,
            onStart: function(element) {
              // scrolling started
            },
            onDone: function(element) {
              // scrolling is done
            },
            onCancel: function() {
              // scrolling has been interrupted
            },
            x: false,
            y: true
          }
        )
      },
      filter: function(evt) {
        evt = (evt) ? evt : window.event;
        let expect = evt.target.value.toString() + evt.key.toString();

        if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
          evt.preventDefault();
        } else {
          return true;
        }
      },
      showForDelivery () {
        this.forDeliveryDialog.show = true
      },
      selectItem (selectedItems) {
        let self = this
        selectedItems.forEach(obj => {
          self.items.unshift(
            {
              booking_detail_id: obj['id'],
              description: obj['item_description'],
              qty: obj['qty'],
              cbm: obj['cbm'],
              rate: obj['rate']
            }
          )

          this.forDeliveryDialog.selected_items.push(obj['id'])
        })

      },
      doClose (){
        this.cancelDelivery()
      },
      doSend (){
        self.loading = true
        this.alerMessage.show = false
        this.$http.secured.post(this.operationsNamespace+'/deliveries/delivered/'+this.id, '')
          .then(response => {
            this.$router.push({ name: 'delivery-orders', query: { added: true, message: "Delivery Order "+this.delivery.delivery_no+" has been successfully completed" } })
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
          })
          .then(function () {
            self.loading = false
          })
      },
      cancelDelivery() {
        this.dialog = {
          show: true,
          title: 'Close Delivery Order',
          body: 'Are you sure you want to close this delivery order?',
          type: 'close',
          item: {},
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      doRefresh (){
        this.getDelivery()
      },
      doSavePrint (){

      },
      doConfirm () {
        this.dialog.show = false

        if(this.dialog.type == 'close'){
          this.$router.push({ name: 'delivery-orders' })
        }else{
          // console.log(JSON.stringify(this.dialog.item))

          if(Object.prototype.hasOwnProperty.call(this.dialog.item, "booking_detail_id")){
            this.deletedItems.push(this.dialog.item.id)
            this.forDeliveryDialog.selected_items.splice(this.forDeliveryDialog.selected_items.indexOf(this.dialog.item.booking_detail_id), 1)
          }else{
            this.forDeliveryDialog.selected_items.splice(this.forDeliveryDialog.selected_items.indexOf(this.dialog.item.id), 1)
          }

          this.items.splice(this.items.indexOf(this.dialog.item), 1)

          if(this.dialog.item.description.length > 0){
            this.showMessage(this.dialog.item.description + " has been successfully deleted", 'success')
          }
        }
      },
      doCancel () {
        this.dialog.show = false
      },
      deleteItem (item) {
        if(item.description.length == 0){
          this.items.splice(this.items.indexOf(item), 1)
          return false
        }
        this.dialog = {
          show: true,
          title: 'Delete Item',
          body: 'Are you sure you want to delete '+item.description+' item?',
          type: 'item',
          item: item,
          confirmBtn: 'Yes',
          cancelBtn: 'No'
        }
      },
      addMoreItems(){
        console.log("addMoreItems");
        this.items.push(
          { description: '', qty: '', cbm: '', rate: '', amount: ''}
        )
      },
      generateItemRows() {
        // for (let i = 0; i < 1; i++) {
        //   this.items.push(
        //     { description: '', qty: '', cbm: '', rate: '', amount: ''}
        //   )
        // }
      },
      getDelivery () {
        this.loading = true
        let self = this
        this.$http.plain.get(this.operationsNamespace+'/deliveries/'+this.id)
          .then(response => {
            this.delivery = response.data
            this.items = this.delivery.items
            this.forDeliveryDialog.client_id = this.delivery.deliver_to
            this.forDeliveryDialog.selected_items = []
            this.deletedItems = []
            this.items.forEach(obj => {
              if(Object.prototype.hasOwnProperty.call(obj, "booking_detail_id")){
                this.forDeliveryDialog.selected_items.push(obj['booking_detail_id'])
              }
            })

            this.generateItemRows()
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
      },
      getDefaultData () {
        let self = this
        this.isStatusLoading = true
        this.$http.plain.get('/default-data?delivery_statuses=true')
          .then(response => {
            this.statuses = response.data.delivery_statuses
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.isStatusLoading = false
          })
      },
      update () {
        let self = this

        let data = {
          deliver_to_contact_no: this.delivery.deliver_to_contact_no,
          deliver_to_address: this.delivery.deliver_to_address,
          ref_no: this.delivery.ref_no,
          delivery_date: this.delivery.delivery_date,
          plate_no: this.delivery.plate_no,
          remarks: this.delivery.remarks,
          items: this.items,
          deleted_items: this.deletedItems
        }

        this.$http.secured.put(this.operationsNamespace+'/deliveries/'+this.id, data)
          .then(response => {
            this.getDelivery()
            this.showMessage(this.delivery.delivery_no + " has been successfully updated", 'success')
          })
          .catch(error => {
            if (error.response) {
              this.alerMessage.messages = error.response.data.messages
              this.alerMessage.show = true
            }else{
              this.showMessage("Something went wrong! Please try again.", 'error')
            }
            this.scrollToElement('body', 'body')
          })
          .then(function () {
            self.loading = false
          })
      },
      async doSave () {
        this.alerMessage.show = false

        if(this.loading){
          return false;
        }

        this.loading = true
        this.update()
      },
      clear () {
        Object.keys(this.delivery).forEach(key => {
          this.delivery[key] = ''
        })

        this.$refs.observer.reset()

        if(this.forUpdate){
          this.getDelivery()
        }
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      }
    },
    mounted() {
      this.getDefaultData()
      this.getDelivery()
    },
    components: {
      SnackBar,
      ConfirmationDialog,
      Loader,
      ActionButtons,
      AlertMessage,
      ForDelivery,
      DeliveryStatus
    }
  }
</script>
